import React, {Component} from 'react'
import LocalStorage from "../../../util/localStorage";
import Resources from "../../../data/services/resources";
import {fillFieldsFromData, getProp} from "../../../util/util";
import {getDialogResource, updateDialogResource} from "../../../data/actions/dialogResource";
import DialogDefault from "../../../components/dialog-default";
import {Field, FieldsManager} from "../../../data/services/fields";
import ProgressBar from "../../../components/progress-bar";
import ResourceFormTab from "../../../components/resource-form-tab";
import Survey from "./survey";

export default class OneOffAssessmentModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tabs: [],
            submitConfirmModal: false,
            confirmModalOpen: false,
            metadata: {}
        };
    }

    /** Lifecycle
     ================================================================= */
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.dialogResource !== prevProps.dialogResource && this.props.dialogResource.data && !this.props.dialogResource.isLoading) {
            let item = getProp(this.props, "dialogResource.data", {});

            const tabs = [
                {name: 'Info', resource: Resources.ClientAssessmentsInfo, isDisabled: !!item.AilmentEdit, isDone: !!item.PartOfBodyID || !!item.QuestionEdit, onClick: (resource) => this.handleTabChange(resource)},
                {name: 'Questions', resource: Resources.ClientOneOffAssessmentsQuestions, isDisabled: !!item.AilmentEdit, isDone: !!item.QuestionEdit, onClick: (resource) => this.handleTabChange(resource)},
                {name: 'Ailment', resource: Resources.ClientOneOffAssessmentsAilment, isDisabled: !item.QuestionEdit, isDone: !!item.AilmentEdit, onClick: (resource) => this.handleTabChange(resource)},
            ]

            this.setState({tabs})
        }

        if (!prevProps.visible && this.props.visible) {
            this.setState({
                selectedTab: null
            }, () => {
                this.handleTabChange(this.props.selectedTab ?? Resources.ClientAssessmentsInfo)
            });
        }
    }

    /** Data Events
     ================================================================= */
    fetchData = () => {
        this.props.dispatch(getDialogResource({
            user: LocalStorage.get("user"),
            query: {
                ClientAssessmentID: this.getId()
            },
            resource: Resources.ClientAssessmentsInfo
        }))
    };

    /** UI Events
     ================================================================= */
    handleTabChange = (resource) => {
        this.setState({
            tabs: this.state.tabs.map((it) => {
                it.current = it.resource === resource;
                return it;
            }),
            selectedTab: resource
        })
    };

    /** Data events
     ================================================================= */
    handleInputChange = (fields, name, value) => {
        let fieldsTmp = FieldsManager.updateField(fields, name, value)
        if ("AssessmentTypeID" === name) {
            this.setState({
                submitConfirmModal: true
            })
        }

        return fieldsTmp
    }

    /** Helpers
     ================================================================= */
    getId = () => {
        return this.props.id;
    };

    getInfoFields = () => {
        let item = getProp(this.props, "dialogResource.data", {});

        const fieldTemplates = {
            AssessmentTypeID: new Field("AssessmentTypeID", '', ['empty'], true, 'select'),
            AssessmentDate: new Field("AssessmentDate", '', [''], true, 'date'),
            ProviderName: new Field("ProviderName", '', [''], true, 'text'),
            Summary: new Field("Summary", '', [''], !!item.AilmentEdit, 'textarea'),
        };

        return fillFieldsFromData(fieldTemplates, item);
    }

    getQuestionFields = () => {
        let item = getProp(this.props, "dialogResource.data", {});

        const fieldTemplates = {
            Notes: new Field("Notes", '', [''], !!item.AilmentEdit, 'textarea'),
        };

        return fillFieldsFromData(fieldTemplates, item);
    }

    getAilmentsFields = () => {
        let item = getProp(this.props, "dialogResource.data", {});

        const fieldTemplates = {
            AilmentIDs: new Field("AilmentIDs", '', [''], !!item.UpdatedByContactID, 'multi-select-search', {}, {
                isMulti: true
            }),
            Summary: new Field("Summary", '', [''], !!item.UpdatedByContactID, 'textarea'),
            DiagnoseDate: new Field("DiagnoseDate", '', [''], true, 'datetime'),
            ProviderName: new Field("ProviderName", '', [''], true, 'readonly'),
            ClientAssessmentPainAilmentID: new Field("ClientAssessmentPainAilmentID", '', [''], true, 'hidden'),
        };

        return fillFieldsFromData(fieldTemplates, item);
    }

    /** Render
     ================================================================= */
    render() {
        const {translate, visible, onClose} = this.props;

        return (
            <DialogDefault
                title={translate("modal.title.one_off_assessment")}
                widthClass="max-w-[1860px]"
                addClass="min-h-[calc(100vh-3rem)]"
                visible={!!visible}
                blurBackdrop={false}
                onClose={onClose}
                translate={translate}
            >
                <React.Fragment>

                    <ProgressBar
                        tabs={this.state.tabs}
                    />

                    {/* Content */}
                    <div className="mt-10">
                        {this.state.selectedTab === Resources.ClientAssessmentsInfo && (
                            <ResourceFormTab
                                tabTitle={"Info"}
                                id={this.getId()}
                                className="mx-auto"
                                dispatch={this.props.dispatch}
                                translate={this.props.translate}
                                resource={this.props.dialogResource}
                                resourceName={this.state.selectedTab}
                                primaryKeyName={"ClientAssessmentID"}
                                handleInputChange={this.handleInputChange}
                                fields={this.getInfoFields()}
                                metadata=""
                                disableSave={this.state.tabs[0]?.isDisabled}
                                disableCancel={this.state.tabs[0]?.isDisabled}
                            />
                        )}
                        {this.state.selectedTab === Resources.ClientOneOffAssessmentsQuestions && (
                            <Survey
                                tabTitle={"Questions"}
                                id={this.getId()}
                                className="mx-auto"
                                dispatch={this.props.dispatch}
                                translate={this.props.translate}
                                resource={this.props.dialogResource}
                                resourceName={this.state.selectedTab}

                                primaryKeyName={"ClientAssessmentOneOffQuestionID"}
                                disableSave={this.state.tabs[1]?.isDisabled}
                                disableCancel={this.state.tabs[1]?.isDisabled}
                                onSubmit={(params) => {
                                    params.ClientAssessmentOneOffQuestionID = getProp(this.props, "dialogResource.data.question.ClientAssessmentOneOffQuestionID", 0);
                                    params.ClientAssessmentID = this.getId()
                                    this.props.dispatch(updateDialogResource({
                                        user: LocalStorage.get("user"),
                                        query: {id: this.getId()},
                                        params: params,
                                        resource: Resources.ClientOneOffAssessmentsQuestions,
                                        piggyResource: Resources.ClientOneOffAssessmentsQuestions
                                    }));
                                }}
                            />
                        )}
                        {this.state.selectedTab === Resources.ClientOneOffAssessmentsAilment && (
                            <ResourceFormTab
                                tabTitle={"Ailment"}
                                id={this.getId()}
                                className="mx-auto"
                                dispatch={this.props.dispatch}
                                translate={this.props.translate}
                                resource={this.props.dialogResource}
                                resourceName={this.state.selectedTab}
                                primaryKeyName={"ClientAssessmentPainAilmentID"}
                                fields={this.getAilmentsFields()}
                                metadata={{
                                    AilmentIDs: {
                                        api: 'api/' + Resources.Ailments,
                                        query: {
                                            searchFields: JSON.stringify({PartOfBodyID: getProp(this.props, "dialogResource.data.PartOfBodyID", 0)})
                                        },
                                        searchMap: (item) => ({
                                            value: item.AilmentID,
                                            label: item.Ailment
                                        })
                                    },
                                }}
                                onSubmit={(params) => {
                                    params.AilmentIDs = params.AilmentIDs.join(', ')
                                    this.props.dispatch(updateDialogResource({
                                        user: LocalStorage.get("user"),
                                        query: {id: this.getId()},
                                        params: params,
                                        resource: Resources.ClientOneOffAssessmentsAilment,
                                        piggyResource: Resources.ClientOneOffAssessmentsAilment
                                    }));
                                }}
                                disableSave={this.state.tabs[2]?.isDisabled || getProp(this.props, "dialogResource.data.UpdatedByContactID", 0)}
                                disableCancel={this.state.tabs[2]?.isDisabled || getProp(this.props, "dialogResource.data.UpdatedByContactID", 0)}
                            />
                        )}
                    </div>
                </React.Fragment>
            </DialogDefault>
        )
    }
}
